import i18n from 'i18n'
import * as React from "react"
import {SelectSeeker} from "ui-seeker/core"

const OPTIONS = [
    {label: 'Real time Parity', value: 'web'},
    {label: 'Metasearches', value: 'meta'},
    {label: 'OTAs', value: 'ota'},
]

// Display-only: value (web/meta/ota) es identidad; solo se traduce el texto.
const SOURCE_KEY = { web: 'common:filters.sourceParity', meta: 'common:filters.sourceMeta', ota: 'common:filters.sourceOta' }

export default function SelectSources({...props}) {

    const myProps = {
        options: OPTIONS,
        formatOptionLabel: opt => i18n.t(SOURCE_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        placeholder: i18n.t('common:filters.allSources'),
        isClearable: true, isMulti: false,
        icon: {icon: 'browser'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}
